import * as Yup from "yup";

export function initialValues(syllabu) {
  return {
    name: syllabu?.name || "",
  };
}

export function validationSchema() {
  return Yup.object({
    name: Yup.string().required("El nombre es obligatorio"),
  });
}
